import React from 'react';
import { BrowserRouter, Link } from 'react-router-dom';

const Nav = () => (
  <BrowserRouter >
    <nav>
      <ul>
        <li>
          <a href="/portfolio">Portfolio</a>
        </li>
        <li>
          <a href="/videos">Videos</a>
        </li>
        <li>
          <a href="/contact">Contact</a>
        </li>
      </ul>
    </nav>
  </BrowserRouter >
);

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Header/Nav.js